import { ConditionalPartial } from '../../../utils';
import { CreateOrganizationRequestDto } from './create-organization.request.dto';

/**
 * DTO for updating organization fields
 * All fields are optional for partial updates
 */
export class UpdateOrganizationRequestDto extends ConditionalPartial(CreateOrganizationRequestDto) {}
